exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".landing{margin-top:10%}.landing .CodeMirror-line{text-align:center;word-wrap:break-word;white-space:pre-wrap;word-break:normal}.landing .singInButton{margin:15px}.landing a,.landing a:visited{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/LandingPage/styles.css
// module id = 588
// module chunks = 1